import SocialProofComponent from "@/components/organisms/social-proof";

export function ParagraphSocialProof({ paragraph, ...props }) {
  const autoSlide = true;
  const slideInterval = 2500;
  const displayType = paragraph?.field_sp_display_type ?? 'logo_with_caption';

  const items = paragraph?.field_sp_items?.map(item => {
    return {
      id: item.id,
      title: item?.field_spi_title?.processed ?? '',
      caption: item?.field_spi_caption?.processed ?? '',
      description: item?.field_spi_description?.processed ?? '',
      logo: item?.field_spi_logo ?? null,
      link: item?.field_spi_link?.url ?? null,
    }
  });

  return (
    <>
      {displayType === "logo_with_caption" && (
        <SocialProofComponent items={items} layout={paragraph?.field_sp_full_screen ? "logos-full-width" : "logos-contained"} autoSlide={autoSlide} slideInterval={slideInterval} />
      )}
      {displayType === "logo_with_title_description" && (
        <SocialProofComponent items={items} layout={"vertical-contained"} autoSlide={autoSlide} slideInterval={slideInterval} />
      )}
    </>
  )
}